import { select, Store } from '@ngrx/store';
import { NotificationState } from './notifications.reducer';
import { Observable } from 'rxjs';
import { Dictionary } from '@ngrx/entity';
import {
  selectCompleteNotification,
  selectIncompleteNotifications,
  selectNotificationsAll,
  selectNotificationsEntities,
} from './notifications.selectors';
import { Notification } from '@gcv/shared';
import { LoadNotifications, ResetNotifications, UpdateNotification } from './notifications.actions';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationsFacade {
  notifications$: Observable<Dictionary<Notification>>;

  constructor(private store: Store<NotificationState>) {
    this.notifications$ = store.pipe(select(selectNotificationsEntities));
  }

  getNotificationsByUserId(userId: string) {
    this.store.dispatch(new LoadNotifications({ userId }));
  }

  completeNotification(notification: Notification) {
    this.store.dispatch(new UpdateNotification(notification));
  }

  resetNotifications() {
    this.store.dispatch(new ResetNotifications());
  }

  selectIncompleteNotifications() {
    return this.store.pipe(select(selectIncompleteNotifications));
  }

  selectCompleteNotifications() {
    return this.store.pipe(select(selectCompleteNotification));
  }

  selectAllNotifications() {
    return this.store.pipe(select(selectNotificationsAll));
  }
}
